// import * as angular from 'angular';
// import {setAngularJSGlobal} from '@angular/upgrade/static';

import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

import * as Sentry from "@sentry/angular";
import {initPlausible} from './app/core/plausible/plausible';




// setAngularJSGlobal(angular);
if (environment.production) {
  enableProdMode();

  // Init Sentry
  Sentry.init({
    dsn: "https://2ee0eb66fedd45ff8a39b781bb7d8779@o1289125.ingest.sentry.io/6634740",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    debug: false,
    environment: (environment.production)? "production":"development",
    release: environment.version,

    tracesSampleRate: 0.2,
  });
}

initPlausible(environment.plausible);

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).catch((e) => {
  console.error(e);
  // HACK: Angular-white-screen-of-death workaround.
  setTimeout(() => {
    window.location.reload();
  }, 2000);
});
